// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"MarksToolbar_Toolbar__2Md1D","Nomobile":"MarksToolbar_Nomobile__1PD9N","Right":"MarksToolbar_Right__3Idn7"};